import { Dimensions, Platform } from "react-native";

import { createPlatformStyles, theme } from "../../theme/theme";
// Define your styles
export const { ids, styles } = createPlatformStyles({
  mobile: {
    containerStyle: {
      width: Dimensions.get("window").width,
      alignItems: "center",
    },
    marginBottom: {
      marginBottom: theme.margin.xlg,
      "@media (min-width: 200px)": {
        marginBottom: theme.margin.mmd,
      },
      "@media (min-width: 700px)": {
        marginBottom: theme.margin.xlg,
      },
    },
    policyText: {
      textAlign: "left",
      fontFamily: theme.fontFamily.robotoSlabBold,
      color: theme.colors.white,
      fontSize: theme.fontsize.md,
      fontWeight: theme.fontweight.medium,
    },
    policyAddressText: {
      textAlign: "left",
      fontFamily: theme.fontFamily.robotoRegular,
      color: theme.colors.white,
      fontSize: theme.margin.md,
    },
    policyStatusText: {
      alignSelf: "flex-start",
      paddingHorizontal: theme.spacing.md,
      paddingVertical: theme.spacing.xs,
      zIndex: theme.zIndex.max,
      elevation: 9,
      overflow: "hidden",
      borderRadius: theme.radius.reg,
      color: theme.colors.white,
      marginTop: theme.margin.reg,
      fontFamily: theme.fontFamily.robotoRegular,
      fontSize: theme.fontsize.reg,
    },
    productDetailsText: {
      color: theme.colors.white,
      fontFamily: theme.fontFamily.robotoBold,
      fontSize: theme.fontsize.reg,
    },
    productDetailsView: {
      position: "absolute",
      top: theme.spacing.none,
      right: theme.spacing.none,
      backgroundColor: theme.colors.black + 30,
      paddingHorizontal: theme.spacing.reg,
      paddingVertical: theme.spacing.xs,
      borderBottomLeftRadius: theme.radius.sm,
      borderBottomRightRadius: theme.spacing.none,
      borderTopLeftRadius: theme.spacing.none,
      borderTopRightRadius: theme.radius.reg,
      overflow: "hidden",
    },
    marginTop: {
      marginTop: theme.margin.sm,
    },
    choosePolicyTabActive: {
      width: "100%",
      ...Platform.select({
        ios: {
          "@media (min-width: 200px)": {
            // iPhone 7, 8
            width: "100%",
          },
          "@media (min-width: 385px)": {
            // iPhone 11, 12
            width: "100%",
          },
          "@media (min-width: 700px)": {
            width: "45%",
          },
          "@media (min-width: 900px)": {
            // orientation: landscape for small iPad
            width: "45%",
          },
          "@media (min-width: 1100px)": {
            width: "45%",
          },
        },
        android: {
          "@media (min-width: 200px)": {
            // Android small devices
            width: "100%",
          },
          "@media (min-width: 385px)": {
            // Android large devices
            width: "100%",
          },
          "@media (min-width: 485px)": {
            // Android small tablet
            width: "50%",
          },
          "@media (min-width: 700px)": {
            // Android medium (Galaxy S4) tablet
            width: "50%",
          },
          "@media (min-width: 900px)": {
            // Android large tablet
            width: "50%",
          },
        },
      }),
      padding: theme.spacing.sm,
      borderWidth: theme.border.medium,
      borderColor: theme.colors.white,
      backgroundColor: theme.colors.white + 20,
      borderRadius: theme.radius.ssm,
    },
    effectiveDateTextMuted: {
      textAlign: "center",
      fontFamily: theme.fontFamily.robotoRegular,
      color: theme.colors.white,
      fontSize: theme.fontsize.cs,
      opacity: 0.7,
    },
    effectiveDateText: {
      textAlign: "center",
      fontFamily: theme.fontFamily.robotoRegular,
      color: theme.colors.white,
      fontSize: theme.fontsize.cs,
    },
    effectiveDateView: {
      flexDirection: "row",
      marginVertical: theme.spacing.xxs,
    },
    choosePolicyCtr: {
      paddingHorizontal: theme.spacing.reg,
      justifyContent: "center",
      alignItems: "center",

      ...Platform.select({
        android: {
          minWidth: "100%",
        },
        ios: {
          minWidth: "100%",
        },
      }),
    },
  },
  web: {
    containerStyle: {
      width: Dimensions.get("window").width,
      alignItems: "center",
    },
    marginBottom: {
      marginBottom: theme.margin.xlg,
      "@media (min-width: 200px)": {
        marginBottom: theme.margin.mmd,
      },
      "@media (min-width: 700px)": {
        marginBottom: theme.margin.xlg,
      },
    },
    policyText: {
      textAlign: "center",
      fontFamily: theme.fontFamily.robotoSlabBold,
      fontWeight: theme.fontweight.bold as any,
      color: theme.colors.white,
      fontSize: theme.fontsize.mmd,
      "@media (min-width: 200px)": {
        fontSize: theme.fontsize.cs,
      },
      "@media (min-width: 600px)": {
        fontSize: theme.fontsize.mmd,
      },
    },
    policyAddressText: {
      textAlign: "center",
      fontFamily: theme.fontFamily.robotoRegular,
      color: theme.colors.white,
      fontSize: theme.fontsize.cs,
      marginVertical: theme.spacing.xxs,
      "@media (min-width: 200px)": {
        fontSize: theme.fontsize.cs,
      },
      "@media (min-width: 600px)": {
        fontSize: theme.fontsize.cs,
      },
    },
    policyStatusText: {
      alignSelf: "flex-start",
      paddingHorizontal: theme.spacing.md,
      paddingVertical: theme.spacing.xs,
      zIndex: theme.zIndex.max,
      elevation: 9,
      overflow: "hidden",
      borderRadius: theme.radius.mmd,
      color: theme.colors.white,
      marginTop: theme.margin.reg,
      fontFamily: theme.fontFamily.robotoRegular,
      fontSize: theme.fontsize.reg,
      "@media (min-width: 200px)": {
        fontSize: theme.fontsize.sm,
      },
      "@media (min-width: 600px)": {
        fontSize: theme.fontsize.reg,
      },
    },
    productDetailsText: {
      color: theme.colors.white,
      fontWeight: theme.fontweight.bold,
      fontFamily: theme.fontFamily.robotoBold,
      fontSize: theme.fontsize.reg,
      "@media (min-width: 200px)": {
        fontSize: theme.fontsize.sm,
      },
      "@media (min-width: 600px)": {
        fontSize: theme.fontsize.reg,
      },
    },
    productDetailsView: {
      position: "absolute",
      top: theme.spacing.none,
      right: theme.spacing.none,
      backgroundColor: theme.colors.black + 30,
      paddingHorizontal: theme.spacing.reg,
      paddingVertical: theme.spacing.xs,
      borderBottomLeftRadius: theme.radius.sm,
      borderBottomRightRadius: theme.spacing.none,
      borderTopLeftRadius: theme.spacing.none,
      borderTopRightRadius: theme.radius.reg,
      overflow: "hidden",
    },
    marginTop: {
      marginTop: theme.margin.sm,
    },
    choosePolicyTabActive: {
      width: "100%",
      "@media (min-width: 200px)": {
        width: 330,
      },
      "@media (min-width: 300px)": {
        width: 340,
      },
      "@media (min-width: 400px)": {
        width: 400,
      },
      "@media (min-width: 600px)": {
        width: 440,
      },
      "@media (min-width: 900px)": {
        width: 450,
      },
      "@media (min-width: 1281px)": {
        width: 450,
      },
      "@media (min-width: 1441px)": {
        width: 450,
      },
      "@media (min-width: 1681px)": {
        width: 500,
      },
      // padding: theme.spacing.sm,
      borderWidth: theme.border.medium,
      borderColor: theme.colors.white,
      backgroundColor: theme.colors.white + 20,
      borderRadius: theme.radius.ssm,
      padding: theme.spacing.sm,
      alignItems: "flex-start",
      paddingHorizontal: 16,
    },
    effectiveDateTextMuted: {
      textAlign: "center",
      fontFamily: theme.fontFamily.robotoRegular,
      color: theme.colors.white,
      fontSize: theme.fontsize.cs,
      opacity: 0.7,
    },
    effectiveDateText: {
      textAlign: "center",
      fontFamily: theme.fontFamily.robotoRegular,
      color: theme.colors.white,
      fontSize: theme.fontsize.cs,
    },
    effectiveDateView: {
      display: "flex",
      flexDirection: "row",
      marginVertical: theme.spacing.xxs,
    },
    choosePolicyCtr: {
      paddingHorizontal: theme.spacing.reg,
      justifyContent: "center",
      alignItems: "center",
    },
  },
});
